import styled from 'styled-components'

import theme from 'theme'

import { underscoreStyles } from 'components/Container'

const Content = styled.div.attrs({
  before: true,
})`
  && h1 {
    font-size: 36px;
    margin: 30px 0 20px;
  }

  && h2 {
    font-size: 30px;
  }

  && h3 {
    font-size: 24px;
  }

  && h4 {
    font-size: 20px;
  }

  && h5 {
    font-size: 18px;
  }

  && h6 {
    font-size: 16px;
  }

  ${({ withUnderscore }) => withUnderscore && underscoreStyles}

  &:before {
    margin: 64px 0;
  }

  span.gatsby-resp-image-wrapper + em,
  img + em,
  div.gatsby-highlight + p > em:only-child,
  video + em,
  iframe + em,
  .captioned + em {
    color: ${theme.colors.blacks[40]};
    font-size: ${theme.fontSizes[40]}px;
    font-style: normal;
    text-align: center;
    display: inline-block;
    margin: 15px auto;
    width: 100%;
  }

  img + em {
    margin-top: -15px;
  }

  div.gatsby-highlight + p > em:only-child {
    position: relative;
    top: -20px;
    margin-bottom: 0;
  }

  div.gatsby-highlight + p > .gatsby-resp-image-wrapper + em {
    position: initial;
  }
`

Content.defaultProps = {
  withUnderscore: true,
}

export default Content
